import { api } from "@/lib/api";

// Sprint 3 — people, users, role templates
export const StudentsAPI = {
  list: (params) => api.get("/students", { params }).then((r) => r.data),
  create: (body) => api.post("/students", body).then((r) => r.data),
  get: (id) => api.get(`/students/${id}`).then((r) => r.data),
  update: (id, patch) => api.patch(`/students/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/students/${id}`).then((r) => r.data),
  siblings: (id) => api.get(`/students/${id}/siblings`).then((r) => r.data),
};

export const ParentsAPI = {
  list: (params) => api.get("/parents", { params }).then((r) => r.data),
  get: (id) => api.get(`/parents/${id}`).then((r) => r.data),
  create: (body) => api.post("/parents", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/parents/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/parents/${id}`).then((r) => r.data),
  listLinks: (parentId) => api.get(`/parents/${parentId}/students`).then((r) => r.data),
  addLink: (parentId, body) => api.post(`/parents/${parentId}/links`, body).then((r) => r.data),
  removeLink: (parentId, linkId) => api.delete(`/parents/${parentId}/links/${linkId}`).then((r) => r.data),
};

export const StaffAPI = {
  list: (params) => api.get("/staff", { params }).then((r) => r.data),
  get: (id) => api.get(`/staff/${id}`).then((r) => r.data),
  create: (body) => api.post("/staff", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/staff/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/staff/${id}`).then((r) => r.data),
};

export const UsersAdminAPI = {
  list: (params) => api.get("/users", { params }).then((r) => r.data),
  create: (body) => api.post("/users", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/users/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/users/${id}`).then((r) => r.data),
  updateRoles: (id, roles) => api.patch(`/users/${id}/roles`, { roles }).then((r) => r.data),
  updateActive: (id, is_active) => api.patch(`/users/${id}/active`, { is_active }).then((r) => r.data),
  passwordReset: (id) => api.post(`/users/${id}/password-reset`).then((r) => r.data),
};

export const RoleTemplatesAPI = {
  list: (params) => api.get("/role-templates", { params }).then((r) => r.data),
  permissions: () => api.get("/permissions").then((r) => r.data),
  create: (body) => api.post("/role-templates", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/role-templates/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/role-templates/${id}`).then((r) => r.data),
  mine: () => api.get("/me/permissions").then((r) => r.data),
};
